import { getCountryFromContext } from "./getCountryFromRequest";

const NOT_FOUND_MESSAGE_RE =
  /no package found|no activity found|invalid slug|not found/i;

function readNested(response) {
  if (!response || typeof response !== "object") return null;
  return response.data ?? response.Data ?? null;
}

function collectCandidates(response) {
  const nested = readNested(response);
  return [response, nested, nested?.data, nested?.Data];
}

export function isInvalidDetailSlug(response) {
  if (!response || typeof response !== "object") return false;

  const flagged = collectCandidates(response).some((item) => {
    if (!item || typeof item !== "object") return false;
    return Boolean(item.invalidSlug ?? item.InvalidSlug);
  });
  if (flagged) return true;

  const message = String(
    response.message ?? response.Message ?? readNested(response)?.message ?? ""
  );
  return NOT_FOUND_MESSAGE_RE.test(message);
}

export function isMissingHolidayDetail(response) {
  if (!response) return true;
  if (isInvalidDetailSlug(response)) return true;

  const data = readNested(response) ?? response;
  if (!data || typeof data !== "object") return true;

  const pkg = data.packageDetails || data.PackageDetails || {};
  return !(
    pkg.packageId ||
    pkg.PackageId ||
    pkg.packageName ||
    pkg.PackageName
  );
}

export function isMissingActivityDetail(response) {
  if (!response) return true;
  if (isInvalidDetailSlug(response)) return true;

  const data = readNested(response) ?? response;
  if (!data || typeof data !== "object") return true;

  const activity = data.activity || data.activities || data;
  return !(
    activity?.activityId ||
    activity?.ActivityId ||
    activity?.activityName
  );
}

export function renderNotFoundPage(context) {
  const isIndia = getCountryFromContext(context) === "IN";

  return {
    redirect: {
      destination: isIndia ? "/in/not-found" : "/not-found",
      permanent: false,
    },
  };
}
